// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"463":"85396659","466":"36a58ae4","563":"b81d34ae","621":"fed37a8a","724":"56b444af"}[chunkId] + ".chunk.js";
};